import { getVitalColorCode } from "@src/helpers/constants";
import React from "react";

interface HealthCardProps {
  title: string;
  value: any;
  unit: string;
  color: string;
  secondaryValue?: string | number;
  cardColor: string;
  backgroundColor?: string;
  icon?: any;
  onClick?: Function;
  secondaryColor?: string;
}

const HealthCard: React.FC<HealthCardProps> = ({
  title,
  value,
  unit,
  color,
  secondaryValue,
  cardColor,
  icon,
  onClick,
  secondaryColor,
}) => {
  return (
    <div
      className="health-card"
      style={{ backgroundColor: cardColor ? cardColor : "#efefef" }}
    >
      <div className="health-card-tittle-icon-container">
        <div
          className="health-card-title"
          style={{ color: icon ? "white" : "" }}
        >
          {title}
        </div>
        <div
          className="health-card-icon"
          onClick={() => (onClick ? onClick() : () => {})}
        >
          {icon}
        </div>
      </div>
      <div className="health-card-value" style={{ color: icon ? "white" : "" }}>
        {unit}
      </div>
      <div className={`health-card-image `} style={{ backgroundColor: color }}>
        <div
          className={`health-card-count-value ${
            secondaryValue && secondaryColor && "is_secondary_card"
          } `}
        >
          {value}
        </div>
        {secondaryValue && secondaryColor && (
          <div
            className="health-second-card-image"
            style={{ backgroundColor: secondaryColor }}
          >
            <div className="health-second-card-count-value">
              {secondaryValue}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HealthCard;
